<template>
  <b-modal ref="target-user-warning-modal" hide-footer title="Target user warning" id="target-user-warning-modal" size="lg" @hide="closeModal()">
    <div class="warning__wrapper">
      <p><span class="font-bold font-italic">Warning: </span>Since you haven't defined target users yet, this survey will be displayed to <strong>anyone</strong> who visits the target page.</p>
      <div class="text-center">
        <button class="mr-2 btn btn-primary" @click="closeModal()">
          OK
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  mounted() {
    this.$refs["target-user-warning-modal"].show()
  },
  methods: {
    closeModal() {
      this.$refs["target-user-warning-modal"].hide()
      this.$emit('closeTargetUserWarningModal')
    },
  }
}
</script>

<style lang="scss" scoped>
.warning__wrapper {
  font-family: "Nunito", sans-serif !important;
}
</style>